<template>
  <modal v-on:closeModalRequest="closeModalRequest()">
    <div class="modal-dealer-registration scrollable -y">
      <div class="header">
        <div class="title">{{myDealerHasPendingRegistration ? 'Register dealer' : 'Update dealer registration'}}</div>
        <div class="description">You can modify any field below by yourself if you find any incorrect information. Please contact our <a href="https://support.chekt.com" target="_blank">support</a> if you need any help.</div>
      </div>

      <transition name="flyInH" mode="out-in">
        
        <div
        v-if="selectedTab === 'addressPicker'"
        v-bind:key="'addressPicker'"
        class="body fixed">
          <comp-address-picker
          v-bind:address="address1"
          v-bind:lat="lat"
          v-bind:lng="lng"
          v-on:onClose="onCloseAddressPicker"></comp-address-picker>
        </div>

        <form
        v-else
        v-bind:key="'registerDealer'"
        v-on:submit="onClickSubmit"
        class="body">
          <div class="content">
            <div class="info-container">
              <div class="label">Company name</div>
              <input id="company-name" type="text" placeholder="Famous Alarm Systems" v-model="name">
            </div>
            <div class="info-container">
              <div class="label">Company address</div>
              <input
              v-on:click="goToAddressPickerTab()" ontouchstart="" style="margin-bottom: 8px;"
              id="company-address1" type="text" placeholder="click to add address" v-model="address1" readonly>
              <input id="company-address2" type="text" placeholder="(optional) e.g. Unit 511, 5th floor" v-model="address2">
            </div>
            <div class="info-container">
              <div class="label">Company main contact (phone)</div>
              <input id="company-main-contact-phone" type="text" placeholder="xxx-xxx-xxxx" v-model="phone">
            </div>
            <div class="info-container">
              <div class="label">Company main contact (email)</div>
              <input id="company-main-contact-email" type="text" placeholder="customercare@yourdomain.com" v-model="email">
            </div>
            <div class="info-container">
              <div class="label">Dealer owner account (can't be modified)</div>
              <input id="primary-admin-email" type="text" placeholder="superadmin@yourdomain.com" v-model="primaryAdminEmail" disabled>
            </div>
            <div class="action-btns flex-end">
              <div
              v-on:click="closeModalRequest()" ontouchstart=""
              class="action-btn">Cancel</div>
              <input
              id="register-dealer"
              type="submit"
              v-bind:value="myDealerHasPendingRegistration ? 'Register' : 'Update'"
              class="action-btn blue" />
            </div>
          </div>
        </form>

      </transition>

    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import CompAddressPicker from '@/components/CompAddressPicker'
export default {
  name: 'modal-dealer-registration',
  components: {
    Modal,
    CompAddressPicker
  },
  computed: {
    myDealer: function () {
      return this.$store.getters.myDealer
    },
    myDealerHasPendingRegistration: function () {
      return this.$store.getters.myDealerHasPendingRegistration
    },
    iAmOwnerOfMyDealer: function () {
      return this.$store.getters.iAmOwnerOfMyDealer
    },
    statusGetMyDealer: function () {
      return this.$store.getters.statusGetMyDealer
    }
  },
  data: function () {
    return {
      selectedTab: 'registerDealer',
      tabs: ['registerDealer', 'addressPicker'],
      name: null,
      address1: null,
      address2: null,
      lat: null,
      lng: null,
      zip: null,
      phone: null,
      email: null,
      primaryAdminEmail: null
    }
  },
  watch: {
    statusGetMyDealer: function () {
      this.initInputs()
    }
  },
  created: function () {
    this.initInputs()
  },
  methods: {
    closeModalRequest: function () {
      this.$emit('closeModalRequest')
      setTimeout(() => { this.getMyDealer() }, 1000)
    },
    onClickSubmit: function (e) {
      e.preventDefault()
      this.closeModalRequest()
      let action = null
      if (this.myDealerHasPendingRegistration) action = this.registerMyDealer
      else action = this.updateMyDealer
      action().then(
        success => {
          this.closeModalRequest()
        },
        failure => {
          this.closeModalRequest()
        }
      )
    },
    initInputs: function () {
      if (this.statusGetMyDealer === 'successful') {
        this.name = this.myDealer.dealerName
        this.address1 = this.myDealer.locationInfo.address1
        this.address2 = this.myDealer.locationInfo.address2
        this.lat = this.myDealer.locationInfo.lat
        this.lng = this.myDealer.locationInfo.lng
        this.phone = this.myDealer.contactInfo.phone
        this.email = this.myDealer.contactInfo.email
        this.primaryAdminEmail = this.myDealer.ownerInfo.email
      }
    },
    goToRegisterDealerTab: function () {
      this.selectedTab = 'registerDealer'
    },
    goToAddressPickerTab: function () {
      this.selectedTab = 'addressPicker'
    },
    onCloseAddressPicker: function ({ address, lat, lng, zip }) {
      this.address1 = address
      this.lat = lat
      this.lng = lng
      this.zip = zip
      this.goToRegisterDealerTab()
    },
    getMyDealer: function () {
      return this.$store.dispatch('getMyDealer')
    },
    registerMyDealer: function () {
      let dealerId = this.myDealer.dealerId
      let name = this.name
      let address1 = this.address1
      let address2 = this.address2
      let zip = this.zip
      let lat = this.lat
      let lng = this.lng
      let phone = this.phone
      let email = this.email
      return this.$store.dispatch('registerMyDealer', {dealerId, name, zip, address1, address2, phone, email, lat, lng})
    },
    updateMyDealer: function () {
      let dealerId = this.myDealer.dealerId
      let name = this.name
      let address1 = this.address1
      let address2 = this.address2
      let zip = this.zip
      let lat = this.lat
      let lng = this.lng
      let phone = this.phone
      let email = this.email
      return this.$store.dispatch('updateMyDealer', {dealerId, name, zip, address1, address2, phone, email, lat, lng})
    }
  }
}
</script>

<style scoped>
.modal-dealer-registration {
  /* common */
  background-color: hsla(0, 100%, 100%, 1);
  border-radius: 5px;
  /* size */
  max-width: 500px;
  max-height: 100%;
  width: 100%;
}

.modal-dealer-registration .header {
  /* common */
  font-size: 14px;
  /* size */
  padding: 20px 32px 20px;
  /* text */
  font-weight: bold;
  /* alignment */
  text-align: left;
}
.modal-dealer-registration .header .title {
  /* common */
  font-size: 2em;
  margin-bottom: 8px;
}
.modal-dealer-registration .header .description {
  /* common */
  font-size: 1em;
  /* text */
  font-weight: normal;
}


.modal-dealer-registration .body {
  /* size */
  padding: 0 32px;
  /* border */
  border-top: 1px solid hsla(0, 100%, 0%, 0.1);
  /* alignment */
  text-align: left;
}
.modal-dealer-registration .body.fixed {
  /* size */
  height: 400px;
  /* position */
  position: relative;
}

.modal-dealer-registration .body .content {
  /* common */
  color: #000;
  font-size: 16px;
  /* size */
  width: 100%;
  min-height: 4em;
  margin: 16px 0;
  /* border */
  /* outline: 1px solid red; */
}


.modal-dealer-registration .body .content .info-container:first-child {
  margin-top: 0;
}
.modal-dealer-registration .body .content .info-container {
  /* size */
  margin: 1em 0;
}
.modal-dealer-registration .body .content .info-container .label {
  font-size: 14px;
  color: var(--gray-high);
  text-align: start;
  margin-bottom: 10px;
}
.modal-dealer-registration .body .content .info-container > input {
  /* common */
  background: white;
  border: solid 1px#e6e6e6;
  border-radius: 5px;
  /* size */
  width: calc(100% - 1em);
  padding: 0.5em;
  font-size: 16px;
  /* padding: 10px; */

  -webkit-transition: -webkit-box-shadow .3s;
  transition: -webkit-box-shadow .3s;
  transition: box-shadow .3s;
  transition: box-shadow .3s,-webkit-box-shadow .3s;
}
.modal-dealer-registration .body .content .info-container > input:disabled {
  /* common */
  background-color: hsla(0, 100%, 0%, 1);
  color: hsla(0, 100%, 100%, 1);
  /* text */
  font-weight: bold;
}




.modal-dealer-registration .body .content .action-btns {
  /* size */
  margin: 1em 0 2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1em;
}
.modal-dealer-registration .body .content .action-btn {
  /* common */
  background-color: white;
  color: var(--gray-high);
  white-space: nowrap;
  border-radius: 5px;
  border: 1px solid var(--border);
  -webkit-box-shadow: 0 0 5px 0 rgba(227,232,238,.42745098039215684);
  box-shadow: 0 0 5px 0 rgba(227,232,238,.42745098039215684);
  /* size */
  width: auto;
  padding: 0.5em 1em;
  /* mouse */
  cursor: pointer;
}
.modal-dealer-registration .body .content .action-btn.blue {
  /* common */
  background-color: var(--primary);
  color: #fff;
}

.flex-end {
  justify-content: end;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/ModalDealerRegistration.vue